import { useParams } from "react-router-dom";
import Stack from "../../components/Utils/Stack.styled";
import Title from "../../components/Utils/Title.styled";
import usePlayListStore from "../../stores/playlistStore";
import { useState, useEffect } from "react";
import PlaylistDetailCard from "../../components/PlaylistDetailCard";
import { motion } from "framer-motion";
import Button from "../../components/Button";
import CONSTANT from "../../constants/constant";
import ErrorMessage from "../../components/ErrorMessage";
import useNavigateParams from "../../helper/navigateHelper";
const PlaylistDetails = () => {
  const navigate = useNavigateParams();
  const { playlistName } = useParams();
  const allPlaylists = usePlayListStore((state) => state.allPlaylists);
  const setCurrentPlayingPlaylist = usePlayListStore(
    (state) => state.setCurrentPlayingPlaylist
  );
  const [currentVideos, setCurrentVideos] = useState(
    allPlaylists.get(playlistName)
  );

  useEffect(() => {
    setCurrentVideos(allPlaylists.get(playlistName));
  }, [allPlaylists, playlistName]);

  const renderPlaylistDetail = (video, i) => {
    return (
      <PlaylistDetailCard
        key={i}
        image={video.thumbnailUrl}
        title={video.title}
      />
    );
  };

  const RenderPlaylist = () => {
    if (currentVideos && currentVideos.length > 0) {
      return (
        <Stack gap="24">
          <Stack
            direction="column"
            gap="0"
            justifyContent="center"
            alignItems="center"
          >
            {currentVideos.map((video, i) => renderPlaylistDetail(video, i))}
          </Stack>
        </Stack>
      );
    }

    return <ErrorMessage message={CONSTANT.ERROR.EMPTY_PLAYLIST} />;
  };

  const playAll = () => {
    let tempVideos = [];
    let index = 0;
    for (const video of currentVideos) {
      tempVideos.push({
        ...video,
        isPlayingNow: index === 0 ? true : false,
      });
      index++;
    }
    setCurrentPlayingPlaylist({ name: playlistName, videos: tempVideos });
    navigate(`/results/${currentVideos[0].videoId}`, {
      q: currentVideos[0].title,
    });
  };

  return (
    <motion.div style={{ width: "100%" }}>
      <Stack
        direction="row"
        marginTop="20px"
        marginBottom="20px"
        gap="20"
        alignItems="center"
      >
        <Title size="24px">{playlistName}</Title>
        <Button
          label={"Play All"}
          padding="8px 20px"
          fontSize="12px"
          type={CONSTANT.ICON.PLAY}
          disabled={currentVideos && currentVideos.length === 0}
          onClick={playAll}
        />
      </Stack>

      <RenderPlaylist />
    </motion.div>
  );
};

export default PlaylistDetails;
